export const getDefaults = (sport = '') => ({
  //choose_options_title: `Choose ${sport} camp options`,
  choose_options_title: `Choose camp options`,
  no_camps_message:
    'No camps available! Please change your selections or choose another date.',
});

const getLocales = async (fileUrl, sport) => {
  try {
    const res = await fetch(fileUrl);
    const data = await res.json();
    if(sport){
      data.choose_options_title = `Choose ${sport} camp options`;
    }
    console.log('Locales Data:', data);
    return Object.assign({}, getDefaults(sport), data);
  } catch (e) {
    console.error('Failed to load external locale file');
    return getDefaults(sport);
  }
};

export default getLocales;
